export enum FOODMENU_SCREEN_LIST {

}

export enum FOODMENU_REQUEST_ID_LIST {
  GET_FOOD_MENU = 'GET_FOOD_MENU',
  GET_FOOD_QC_KEYWORD = 'GET_FOOD_QC_KEYWORD',
  POST_FOOD_MENU = 'POST_FOOD_MENU',
  PATCH_FOOD_MENU = 'PATCH_FOOD_MENU',
  DELETE_FOOD_MENU = 'DELETE_FOOD_MENU',
  GET_TAG_MENU = 'GET_TAG_MENU',
}

export enum FOODMENU_TRANSLATION_KEY {
  MENU_NAME_TH_DUP = 'menuName_is_duplicated',
  MENU_NAME_EN_DUP = 'menuNameEN_is_duplicated',
  MENU_NAME_TH_INVALID = 'menuName_is_invalid',
  MENU_NAME_EN_INVALID = 'menuNameEN_is_invalid',
  MENU_SKU_ID_INVALID = 'menuSKUId_is_invalid',
  MENU_SKU_ID_REQUIRED = 'menuSKUId_is_required',
  MENU_DESC_TH_INVALID = 'menuDescription_is_invalid',
  MENU_DESC_EN_INVALID = 'menuDescriptionEN_is_invalid',
  MENU_CATEGORY_NOT_FOUND = 'menuCategory_not_found',
  MENU_NOT_FOUND = 'menu_not_found',
  MENU_TAGS_NOT_FOUND = 'tag_not_found',
}

export enum FOODMENU_INLINE_ERROR {
  MENU_NAME_DUP = 'ชื่ออาหารซ้ำ กรุณาตั้งใหม่',
  MENU_NAME_TH_INVALID = `ต้องเป็นตัวอักษร ตัวเลข หรือเครื่องหมาย _ - * ' " # & () @ + % . <> | ® / เท่านั้น`,
  MENU_NAME_EN_INVALID = `ต้องเป็นตัวอักษรภาษาอังกฤษ ตัวเลข หรือเครื่องหมาย _ - * ' " # & () @ + % . <> | ® / เท่านั้น`,
  MENU_SKU_ID_INVALID = `ต้องเป็นตัวอักษร ตัวเลข หรือเครื่องหมาย _ - * ' " # & () @ + % . <> | ® / เท่านั้น`,
  MENU_DESC_TH_INVALID = `ต้องเป็นตัวอักษร ตัวเลข หรือเครื่องหมาย _ - * ' " # & () @ + % . <> | ® / เท่านั้น`,
  MENU_DESC_EN_INVALID = `ต้องเป็นตัวอักษรภาษาอังกฤษ ตัวเลข หรือเครื่องหมาย _ - * ' " # & () @ + % . <> | ® / เท่านั้น`,
  MENU_TAGS_TH_INVALID = `กรุณาเลือกประเภทใหม่อีกครั้ง`,

  // menu discount inline error
  DISCOUNT_PRICE_UNDEFINED = 'กรุณาระบุราคาที่ลดแล้ว',
  DISCOUNT_PRICE_INVALID = 'ราคาลดต้องไม่เกิน %s% ของราคาเต็ม',
  DISCOUNT_PRICE_LESS_THAN_NORMAL_PRICE = 'ราคาลดต้องน้อยกว่าราคาเต็ม',
  DISCOUNT_START_DATE_UNDEFINED = 'กรุณาระบุวันเริ่มต้น',
  DISCOUNT_START_TIME_UNDEFINED = 'กรุณาระบุเวลาเริ่มต้น',
  DISCOUNT_START_DATETIME_INVALID = 'กรุณาระบุวันเวลาเริ่มต้นที่ถูกต้อง',
  DISCOUNT_END_DATE_UNDEFINED = 'กรุณาระบุวันสิ้นสุด',
  DISCOUNT_END_TIME_UNDEFINED = 'กรุณาระบุเวลาสิ้นสุด',
  DISCOUNT_DURATION_INVALID = 'ระยะเวลาโปรโมชันต้องมากกว่า 30 นาที'

}

export enum MNQC_STATUS {
  MNQC_APPROVE = 'MNQC-APPROVE',
  MNQC_REJECT = 'MNQC-REJECT',
  MNQC_NEW = 'MNQC-NEW',
  MNQC_PENDING_CAN_SELL = 'MNQC-CANSELL',
  MNQC_PENDING_CANNOT_SELL = 'MNQC-CANNOTSELL',
}

export const MENU_PRICE_REGEX = /^([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)$/;
export const MENU_PRICE_MAXLENGTH = 9;
